
import * as React from 'react';
import { withCurrentItemSet } from '../decorators/selectors';
import { withPageLoadTracker } from '../decorators/withPageLoadTracker';
import { EmptyFolder, IEmptyFolderBaseProps, IEmptyFolderProps } from './EmptyFolder';
import { IPageLoadTrackerProps } from '../pageLoadTracker/PageLoadTracker';
import { childItemsFacet } from '../../facets/SetFacets';

export const ItemsEmptyFolder = withCurrentItemSet()(
  withPageLoadTracker([childItemsFacet])(EmptyFolder)
);

// @ts-ignore
type __unused_declarations = Pick<
  React.StatelessComponent |
  IPageLoadTrackerProps |
  IEmptyFolderBaseProps |
  IEmptyFolderProps,
  never>;
